import React from 'react';

import { Modal } from 'src/components/common';
import { OpenDataDisputeModalForm } from 'src/components/consumer';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

import { OpenDataDisputeModalArgs } from './types';

export const OpenDataDisputeModal: React.FC = () => {
  const { closeModal, isOpen, switchClosability, args } = useModal<OpenDataDisputeModalArgs>(
    ModalId.CreateDataDisputeModal,
  );

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const [employerId, cb] = React.useMemo(
    () => [args?.employerId, args?.cb],
    [args?.cb, args?.employerId],
  );

  return (
    <Modal
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={550}
    >
      <OpenDataDisputeModalForm
        employerId={employerId}
        cb={cb}
        onCloseModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
